import store from '../../../store/store'

import('./toggle_item.css')
export default function ToggleItem(opts={}){
    BaseConstructor.call(this)
    let {container,id, title,desc} = opts
    let elements = {}
    let context = this

    this.generate = () =>{
        let current = store.mainConfigStore.getConfig(id)
        elements.container = this.createElement('div', `config-modal-toggle-item-container ${current ? 'active' : ''}`, '')
        elements.title_wrapper = this.createElement('div', 'config-modal-toggle-item-title-wraper')
        elements.title = this.createElement('div', 'config-modal-toggle-item-title', title)
        elements.desc = this.createElement('div', 'config-modal-toggle-item-desc', desc)
        elements.selected_icon = this.createElement('div', 'config-modal-toggle-item-check', '<span class="fas fa-check"></span>')

        $(elements.title_wrapper).append(elements.title, elements.desc)
        $(elements.container).append(elements.title_wrapper, elements.selected_icon)
        $(container).append(elements.container)

        eventsHandler()
    }

    this.update = () =>{
        let current = store.mainConfigStore.getConfig(id)
        $(elements.container).toggleClass('active', current)        
    }

    const eventsHandler = () =>{
        $(elements.container).on('click', _=>{
            let current = store.mainConfigStore.getConfig(id)
            store.mainConfigStore.setConfig(id, !current)
        })

        store.mainConfigStore.subscribe('SET_CONFIG', data=>{
            if(data.path === id){
                this.update()
            }
        })
    }
}

ToggleItem.prototype = Object.create(BaseConstructor.prototype)